var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumbSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 1.83203C5.94065 1.83203 1.83398 5.9387 1.83398 10.9987C1.83398 16.0587 5.94065 20.1654 11.0007 20.1654C16.0607 20.1654 20.1673 16.0587 20.1673 10.9987C20.1673 5.9387 16.0607 1.83203 11.0007 1.83203ZM14.6948 11.4845L11.9448 14.2345C11.8073 14.372 11.6332 14.4362 11.459 14.4362C11.2848 14.4362 11.1107 14.372 10.9732 14.2345C10.7073 13.9687 10.7073 13.5287 10.9732 13.2629L12.5498 11.6862H7.79232C7.41648 11.6862 7.10482 11.3745 7.10482 10.9987C7.10482 10.6229 7.41648 10.3112 7.79232 10.3112H12.5498L10.9732 8.73453C10.7073 8.4687 10.7073 8.0287 10.9732 7.76286C11.239 7.49703 11.679 7.49703 11.9448 7.76286L14.6948 10.5129C14.9607 10.7787 14.9607 11.2187 14.6948 11.4845Z",
    fill: "#EB2019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbSeparator);
export default __webpack_public_path__ + "static/media/breadcrumb-separator.8ebef9a69dc5a8888c2f3026298c39ea.svg";
export { ForwardRef as ReactComponent };